import angular from 'angular';

import ApiClass from './ApiClass';
import AuthClass from './AuthClass';
import CategoryClass from './CategoryClass';
import CoursesClass from './CoursesClass';
import EventClass from './EventClass';
import HelperClass from './HelperClass';
import JwtClass from './JwtClass';
import MsTeamsClass from './MsTeamsClass';
import ProfileClass from './ProfileClass';
import RegulatorClass from './RegulatorClass';
import ResolveClass from './ResolveClass';
import Swal from './Swal';
import TimeZoneClass from './TimeZoneClass';
import UserClass from './UserClass';
import VendorClass from './VendorClass';

export default angular
  .module('app.services', [])
  .service('ApiClass', ApiClass)
  .service('AuthClass', AuthClass)
  .service('CategoryClass', CategoryClass)
  .service('CoursesClass', CoursesClass)
  .service('EventClass', EventClass)
  .service('HelperClass', HelperClass)
  .service('JwtClass', JwtClass)
  .service('MsTeamsClass', MsTeamsClass)
  .service('ProfileClass', ProfileClass)
  .service('RegulatorClass', RegulatorClass)
  .service('ResolveClass', ResolveClass)
  .service('Swal', Swal)
  .service('TimeZoneClass', TimeZoneClass)
  .service('UserClass', UserClass)
  .service('VendorClass', VendorClass).name;



// WEBPACK FOOTER //
// ./src/app/services/index.js